import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { Plus, Smartphone, Bike, XCircle } from "lucide-react";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { formatDate } from "@/lib/formatters";
import { EmptyState } from "@/components/forms/EmptyState";

interface Venta {
  id: string;
  numero_consecutivo: number;
  fecha_venta: string;
  cliente_nombre: string;
  tipo_producto: "moto" | "celular";
  producto_marca: string;
  producto_modelo: string;
  valor_total: number;
  estado: "borrador" | "confirmada" | "anulada";
}

export function VentasListPage() {
  const { data, isLoading } = useList<Venta>({
    resource: "ventas",
    sorters: [{ field: "registrado_en", order: "desc" }],
    pagination: { pageSize: 50 },
  });

  return (
    <div>
      <PageHeader
        title="Ventas"
        actions={
          <Link to="/ventas/nueva" className="btn-primary inline-flex items-center gap-2">
            <Plus className="size-4" /> Nueva venta
          </Link>
        }
      />

      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : data?.data.length === 0 ? (
        <EmptyState
          title="Aún no hay ventas"
          description="Toca el botón Nueva venta para empezar."
        />
      ) : (
        <ul className="space-y-2">
          {data?.data.map((v) => (
            <li key={v.id}>
              <Link to={`/ventas/${v.id}`} className="card p-4 flex items-center gap-3 hover:bg-bg">
                {v.tipo_producto === "celular" ? (
                  <Smartphone className="size-5 text-fg-muted" />
                ) : (
                  <Bike className="size-5 text-fg-muted" />
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-medium truncate">
                    #{v.numero_consecutivo} · {v.cliente_nombre}
                  </p>
                  <p className="text-sm text-fg-muted truncate">
                    {v.producto_marca} {v.producto_modelo} · {formatDate(v.fecha_venta)}
                  </p>
                </div>
                <div className="text-right">
                  <MoneyDisplay value={v.valor_total} className="font-medium" />
                  {v.estado === "anulada" && (
                    <p className="text-xs text-error flex items-center gap-1 justify-end mt-0.5">
                      <XCircle className="size-3" /> Anulada
                    </p>
                  )}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
